import { useCallback, useEffect, useState } from "react";
import outdoorAreasIcon from "../../../icons/outdoor-areas.svg";
import { RouteBuilder } from "../../router/constantes/routes.const";

export const useOutdoorAreas = (hasOutdoorAreas: boolean,
                                name: string,
                                id: string,
                                numberOfAnnotations: number,
                                isExported: boolean,
                                numberOfAnnotationsOnArea: number,
                                locale?: string | null,
                                organizationCode?: string | null) => {
  const [outdoorAreas, setOutdoorAreas] = useState<{
    id: string;
    name: string;
    icon: string,
    numberOfAnnotations: number,
    isExported: boolean,
    numberOfAnnotationsOnArea: number
  }[]>([]);

  useEffect(() => {
    if (hasOutdoorAreas) {
      setOutdoorAreas([{ name, id, icon: outdoorAreasIcon, numberOfAnnotations: numberOfAnnotations, isExported: isExported, numberOfAnnotationsOnArea: numberOfAnnotationsOnArea }]);
    } else {
      setOutdoorAreas([]);
    }
  }, [setOutdoorAreas, hasOutdoorAreas, name, id, numberOfAnnotations, isExported, numberOfAnnotationsOnArea]);

  const outdoorAreasRouterLinkCallback = useCallback((siteId: string) => RouteBuilder.outdoorAreas(id, locale, organizationCode), [id, locale, organizationCode]);

  return {
    outdoorAreas,
    outdoorAreasRouterLinkCallback,
  };
};
